import {useState, useEffect } from 'react';
import axios from "axios";
import {Dialog, DialogActions, DialogContent, DialogTitle, Grid, Button, Typography, IconButton, Badge} from "@material-ui/core";
import NewReleasesIcon from "@material-ui/icons/NewReleases";
const ITEMS_PER_PAGE = 5;

const ReleaseNotes = () => {
  const [open, setOpen] = useState(false);
  const [notes, setNotes] = useState([]);
  const [page, setPage] = useState(0);
  const [isNew, setIsNew] = useState(0);
  const api_url = window.API_URL
  const color = "inherit"
  const id = open ? 'notification-popover' : undefined;

  useEffect(() => {
    axios.get(`${api_url}/api/v1.0/release-notes/`).then(res => {
      setNotes(res.data);
      const seen = localStorage.getItem('release_version');
      console.log('seen', seen, res.data[0]?.version)
      if (seen !== res.data[0]?.version) setIsNew(1);
    });
  }, []);
  const handleOpen = () => {
    setPage(0);
    setOpen(true);
    localStorage.setItem('release_version', notes[0]?.version);
    setIsNew(0);
  };

  const olderNotes = notes.slice(1);
  const totalOlderPages = Math.ceil(olderNotes.length / ITEMS_PER_PAGE);
  const totalPages = 1 + totalOlderPages;

  const getCurrentItems = () => {
    if (page === 0) return [notes[0]];
    const start = (page - 1) * ITEMS_PER_PAGE;
    return olderNotes.slice(start, start + ITEMS_PER_PAGE);
  };

  const currentItems = getCurrentItems();

  const renderRelease = (release, idx) => (
    <div key={idx} style={{ marginBottom: 20 }}>
      <Grid container alignItems="center" style={{ marginBottom: 8, gap: 8 }}>
        <Typography style={{
          background: "#1976d2", color: "#fff",
          borderRadius: 12, padding: "2px 10px", fontSize: 13, fontWeight: 700
        }}>
          v{release?.version}
        </Typography>
        <Typography style={{ color: "#999", fontSize: 12 }}>{release?.date}</Typography>
        {idx === 0 && page === 0 && (
          <Typography style={{
            background: "#e8f5e9", color: "#388e3c",
            borderRadius: 12, padding: "2px 10px", fontSize: 12
          }}>
            Dernière version
          </Typography>
        )}
      </Grid>

      {release.categories ? (
        Object.entries(release.categories).map(([cat, items]) => (
          <div key={cat} style={{ marginBottom: 12 }}>
            <Typography style={{ fontWeight: 600, fontSize: 13, color: "#555", marginBottom: 4 }}>
              {cat}
            </Typography>
            <ul style={{ margin: 0, paddingLeft: 20 }}>
              {items.map((note, i) => (
                <li key={i}><Typography style={{ fontSize: 13 }}>{note}</Typography></li>
              ))}
            </ul>
          </div>
        ))
      ) : (
        <ul style={{ margin: 0, paddingLeft: 20 }}>
          {release.notes?.map((note, i) => (
            <li key={i}><Typography style={{ fontSize: 13 }}>{note}</Typography></li>
          ))}
        </ul>
      )}

      {idx < currentItems.length - 1 && (
        <hr style={{ border: "none", borderTop: "1px solid #eee", margin: "16px 0" }} />
      )}
    </div>
  );

  return (
    <>
      <IconButton
        color={color}
        aria-describedby={id}
        onClick={handleOpen}
        style={{ padding: 12 }}
      >
        <Badge badgeContent={isNew} color="error">
          <NewReleasesIcon />
        </Badge>
      </IconButton>

      <Dialog open={open} onClose={() => setOpen(false)} PaperProps={{ style: { width: 560 } }}>
        <DialogTitle>
          <Grid container alignItems="center" justifyContent="space-between">
            <Typography variant="h6" style={{ fontWeight: 700 }}>Release Notes</Typography>
            <Typography variant="caption" style={{ color: "#999" }}>
              {page + 1} / {totalPages}
            </Typography>
          </Grid>
        </DialogTitle>

        <DialogContent dividers>
          {notes.length > 0 && currentItems.map((release, idx) => renderRelease(release, idx))}
        </DialogContent>

        <DialogActions>
          <Button size="small" disabled={page === totalPages - 1} onClick={() => setPage(prev => prev + 1)}>
            ← Précédent
          </Button>
          <Typography style={{ flex: 1, textAlign: "center", fontSize: 12, color: "#999" }}>
            {Array.from({ length: totalPages }).map((_, i) => (
              <span
                key={i}
                onClick={() => setPage(i)}
                style={{
                  display: "inline-block", width: 8, height: 8, borderRadius: "50%",
                  background: i === page ? "#1976d2" : "#ccc",
                  margin: "0 3px", cursor: "pointer"
                }}
              />
            ))}
          </Typography>
          <Button size="small" disabled={page === 0} onClick={() => setPage(prev => prev - 1)}>
            Suivant →
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};
export default ReleaseNotes;
